import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getJackpotHistoryList = (params) => {
    return axios.get(`${backendHost}/api/admin/jackpot/history/list`, {params});
};

export {
    getJackpotHistoryList
}